module.exports = __webpack_public_path__ + "img/lbc.900dfc2b.svg";